const PUBLIC_URL = process.env.PUBLIC_URL || "";

export const galleryCategories = [
  {
    id: "events",
    label: "Events & Activations",
    description:
      "Corporate gatherings, launches, and special experiences produced by Aura International.",
    images: [
      { src: `${PUBLIC_URL}/Images/event1.jpg`, alt: "Corporate event with elegant stage lighting" },
      { src: `${PUBLIC_URL}/Images/event2.jpg`, alt: "Brand activation with guests networking" },
      { src: `${PUBLIC_URL}/Images/event3.jpg`, alt: "Conference audience during keynote" },
      { src: `${PUBLIC_URL}/Images/event4.jpg`, alt: "Decorated venue with floral details" },
      { src: `${PUBLIC_URL}/Images/event5.jpg`, alt: "Premium table setup for gala dinner" },
      { src: `${PUBLIC_URL}/Images/event6.jpg`, alt: "Ambient lighting design at an evening event" },
      { src: `${PUBLIC_URL}/Images/event7.jpg`, alt: "Guests enjoying a live experience" },
      { src: `${PUBLIC_URL}/Images/event8.jpg`, alt: "Large scale venue with production rigging" },
      { src: `${PUBLIC_URL}/Images/event9.jpg`, alt: "Event detail shot with decor elements" },
      { src: `${PUBLIC_URL}/Images/event10.jpg`, alt: "Stage and LED screen setup" },
      { src: `${PUBLIC_URL}/Images/event11.jpg`, alt: "Event crowd captured from above" },
      { src: `${PUBLIC_URL}/Images/event12.jpg`, alt: "Networking area with branded backdrop" },
      { src: `${PUBLIC_URL}/Images/event13.jpg`, alt: "Close-up of event ambience and styling" },
    ],
  },
  {
    id: "construction-interior",
    label: "Construction & Interior",
    description:
      "Spaces and environments we have helped plan, coordinate, and bring to life.",
    images: [
      { src: `${PUBLIC_URL}/Images/construction.jpg`, alt: "Construction site with structural work in progress" },
      { src: `${PUBLIC_URL}/Images/construction1.jpg`, alt: "Interior under fit-out with exposed services" },
      { src: `${PUBLIC_URL}/Images/construction2.jpg`, alt: "Completed interior corridor with premium finishes" },
      {
        src: `${PUBLIC_URL}/Images/interiourdesignherosection.jpg`,
        alt: "Warm interior fit-out with natural light and wood structure",
      },
    ],
  },
  {
    id: "fashion-beauty",
    label: "Fashion & Beauty",
    description:
      "Campaign, retail, and lifestyle visuals for fashion and beauty clients.",
    images: [
      {
        src: `${PUBLIC_URL}/Images/fashion1.jpg`,
        alt: "Editorial fashion portrait with soft lighting",
      },
      {
        src: `${PUBLIC_URL}/Images/fashion2.jpeg`,
        alt: "Beauty product still life styled for social media",
      },
      {
        src: `${PUBLIC_URL}/Images/fashion3.jpeg`,
        alt: "Runway-inspired look with premium styling",
      },
      {
        src: `${PUBLIC_URL}/Images/fashion4.jpeg`,
        alt: "Close-up of beauty detailing and textures",
      },
      {
        src: `${PUBLIC_URL}/Images/fashion5.jpg`,
        alt: "Campaign image with models in coordinated outfits",
      },
      {
        src: `${PUBLIC_URL}/Images/fashion6.jpg`,
        alt: "Lifestyle shot from a fashion or beauty launch event",
      },
    ],
  },
  {
    id: "social-digital",
    label: "Social & Digital",
    description:
      "Content-led moments and visuals that translate well to social and digital channels.",
    images: [
      {
        src: `${PUBLIC_URL}/Images/digital1.jpg`,
        alt: "Social media grid-style layout showcasing multiple posts",
      },
      {
        src: `${PUBLIC_URL}/Images/digital2.jpg`,
        alt: "Analytics dashboard representing campaign performance",
      },
      {
        src: `${PUBLIC_URL}/Images/digital3.jpg`,
        alt: "Creative digital ad mockups for multiple devices",
      },
      {
        src: `${PUBLIC_URL}/Images/digital4.jpg`,
        alt: "Content calendar and strategy planning visuals",
      },
      {
        src: `${PUBLIC_URL}/Images/digital5.jpg`,
        alt: "Social media engagement and community interaction concept",
      },
    ],
  },
];

export const allGalleryImages = galleryCategories.flatMap((category) => category.images);

export const serviceGalleryMap = {
  "event-management": ["events"],
  "social-digital": ["social-digital"],
  "construction-interior": ["construction-interior"],
  "fashion-beauty": ["fashion-beauty"],
};

